import { render, staticRenderFns } from "./upload-imageOneOneCopy.vue?vue&type=template&id=194aff8f&scoped=true"
import script from "./upload-imageOneOneCopy.vue?vue&type=script&lang=ts"
export * from "./upload-imageOneOneCopy.vue?vue&type=script&lang=ts"
import style0 from "./upload-imageOneOneCopy.vue?vue&type=style&index=0&id=194aff8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194aff8f",
  null
  
)

export default component.exports